module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }